import { render } from "./ShowSessionExpiredError.vue?vue&type=template&id=126635c8"
import script from "./ShowSessionExpiredError.vue?vue&type=script&lang=js"
export * from "./ShowSessionExpiredError.vue?vue&type=script&lang=js"

import "./ShowSessionExpiredError.vue?vue&type=style&index=0&id=126635c8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__